import {Invoice} from './invoice';
import {AbstractBilling} from './abstract-billing';

export class BillingRequest extends AbstractBilling {
  invoice: Invoice | null = null;
  deferred: boolean = false;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.invoice) {
      this.invoice = new Invoice().deserialize(input.invoice);
    }

    return this;
  }
}
